import { t, Translation } from "../../../core/translate";
import { MultiColorCovers, QuestionMark } from "./icons";
import { Button } from "@vitalsource/vstui";
import React from "react";
import styled from "styled-components";
import { cloud, ninja, ocean } from "@vitalsource/vstui/colors";
import { Popover } from "@vitalsource/vstui/labs";
import { createThemedComponent } from "@vitalsource/vstui/themes";
import { selectors as brandSelectors } from "../../../../redux/brand";
import { actions as modalActions } from "../../../../redux/modals";
import { actions as storageActions } from "../../../../redux/storage";
import { connect } from "react-redux";
import {
  actions as feedbackActions,
  selectors as feedbackSelectors
} from "../../../../redux/feedback";
import { OffScreenSpan } from "../promotions-lane/promotion-element";

const Explore = styled.div`
  align-items: center;
  border-bottom: 1px solid ${cloud.getShade(4)};
  display: flex;
  flex-direction: column;
  padding: 35px 0 29px;

  h4 {
    font-weight: 400;
    letter-spacing: 0;
  }

  svg {
    padding: 14px 12px 7px;
  }
`;

const Header = styled.h4`
  color: ${ocean.getShade(8)};
  font-size: 1.6rem;
`;

const List = styled.ul`
  color: ${ninja.getShade(10)};
  font-size: 1.4rem;
  font-weight: 400;
  letter-spacing: 0;
  padding: 11px 0 10px 16px;

  li {
    display: flex;
    padding: 8px 0;
  }
`;

const MenuContent = ({
  openFeedback,
  showFeedback,
  isFeedbackExternal,
  showSupport,
  supportLink,
  supportLabel,
  brandName,
  openWelcomeModal,
  showOnboarding,
  showMissingBooks
}) => (
  <div>
    {showOnboarding && (
      <Explore>
        <Header>
          <Translation id="library.explore-bookshelf" brand={brandName}>
            Explore Bookshelf
          </Translation>
        </Header>
        <MultiColorCovers />
        <Button
          onClick={openWelcomeModal}
          data-interaction-id="question_menu_whats_new"
        >
          <Translation id="library.whats-new">What's New</Translation>
        </Button>
      </Explore>
    )}
    <List>
      {showFeedback && (
        <li>
          <Button
            inline
            naked
            onClick={openFeedback}
            data-interaction-id="question_menu_show_feedback"
          >
            <Translation id="footer.feedback">
              Give General Feedback
            </Translation>
            {isFeedbackExternal && (
              <OffScreenSpan>
                <Translation id="base.new-window">New Window</Translation>
              </OffScreenSpan>
            )}
          </Button>
        </li>
      )}
      {showMissingBooks && (
        <li>
          <Button
            inline
            href={t("locations.zendesk-missing-books")}
            target="_blank"
            data-interaction-id="question_menu_where_are_my_books"
          >
            <Translation id="footer.where-are-my-books">
              Where are my books?
            </Translation>
          </Button>
        </li>
      )}
      {showSupport && (
        <li>
          <Button
            inline
            href={supportLink}
            target="_blank"
            data-interaction-id="question_menu_support"
          >
            {supportLabel}
          </Button>
        </li>
      )}
    </List>
  </div>
);

export const ThemedButton = createThemedComponent(Button, {
  Button_boxShadow_themePrimaryNaked_focus: `0 0 0 2px rgba(255, 255, 255, 0.8)`
});

const QuestionMarkAndMenu = props => {
  if (!props.enabled) {
    return null;
  }
  return (
    <Popover
      content={
        <MenuContent
          openFeedback={props.openFeedback}
          showFeedback={props.showFeedback}
          isFeedbackExternal={props.isFeedbackExternal}
          showSupport={props.showSupport}
          supportLabel={props.supportLabel}
          supportLink={props.supportLink}
          openWelcomeModal={props.openWelcomeModal}
          showOnboarding={props.showOnboarding}
          brandName={props.brandName}
          showMissingBooks={props.showMissingBooks}
        />
      }
    >
      <ThemedButton
        iconStart={<QuestionMark />}
        label={t("base.help", "Help")}
        naked
        data-interaction-id="question_menu_open"
      />
    </Popover>
  );
};

const mapStateToProps = state => ({
  enabled: brandSelectors.getBrandValue(state, "Footer.Help.enabled", true),
  showFeedback: brandSelectors.getBrandValue(state, "Feedback.enabled"),
  showSupport: brandSelectors.getBrandValue(state, "Support.visible"),
  supportLink: brandSelectors.getBrandValue(state, "Support.url"),
  showMissingBooks: brandSelectors.getBrandValue(
    state,
    "Support.MissingBooks.enabled"
  ),
  brandName: brandSelectors.getBrandValue(state, "name"),
  supportLabel:
    brandSelectors.getBrandValue(
      state,
      "Support.label",
      t("footer.support", "Contact Support")
    ) || t("footer.support", "Contact Support"),
  showOnboarding: brandSelectors.shouldShowOnboarding(state),
  isFeedbackExternal: feedbackSelectors.isFeedbackExternal(state)
});

const mapDispatchToProps = dispatch => ({
  openFeedback: () => {
    dispatch(feedbackActions.openFeedback());
  },
  openWelcomeModal: () => {
    dispatch(modalActions.openModal("WelcomeOnboarding"));
    dispatch(storageActions.setHasSeenWelcomeOnboarding());
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuestionMarkAndMenu);
